var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 7.66602,
  width: 12,
  height: 1,
  fill: "currentColor"
})));
export { SvgMinus as ReactComponent };
export default new URL("/home/runner/_work/motorway-dealer-webapp/motorway-dealer-webapp/components/Gallery/icons/minus.svg", import.meta.url).toString();